<template>
  <div class="field-group-modal" v-if="showModal">
    <div class="modalHeader" style="border-radius: 9px 9px 0px 0px !important;">
      <span class="title">Manage Field Groups</span>
      <span @click="closeModal" class="btn-close float-right"><i class="fas fa-times"></i></span>
    </div>

    <div class="modalBody">
      <table class="table table-bordered table-striped table-hover table-sm">
        <thead>
          <tr>
            <th>Name</th>
            <th>Label</th>
            <th>Help Text</th>
            <th># Fields</th>
            <th>Max Checked</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(group, index) in groups" :key="index" v-if="group.fields !== undefined">
            <td>{{ group.name }}</td>
            <td>{{ group.title }}</td>
            <td>{{ group.desc }}</td>
            <td>{{ Object.keys(group.fields).length }}</td>
            <td>{{ $store.getters.fieldGroupMaxFields(group.fieldId) }}
            <td>
              <button class="btn btn-sm btn-light" @click="editGroup(index)">Edit</button>
              <button class="btn btn-sm btn-danger" @click="deleteGroup(index)">Delete</button>
              <button class="btn btn-sm btn-light" v-if="group.hide === true" @click="sendToQuestionnaire(group.fieldId)">Send to Questionnaire</button>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="button-box float-right mb-3 mr-0">
        <button class="btn btn-secondary" @click="closeModal">Close</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'field-group-modal',

  mounted () {
    let that = this
    this.$on('showModal', function (fieldData) {
      that.showModal = true
      that.groups = JSON.parse(JSON.stringify(that.$store.getters.groupFields()))
    })

    document.addEventListener('keyup', this.keyCheck)
  },

  beforeDestroy () {
    document.removeEventListener('keyup', this.keyCheck, false)

    this.$off('showModal')
  },

  data () {
    return {
      showModal: false,
      groups: {}
    }
  },

  methods: {
    sendToQuestionnaire (nameFieldGroup) {
      let newGroup = null
      let groupModel = ''
      let positionFieldGroup = null
      let pageFieldGroup = null
      let tabsOrderModel = []
      let tabsOrderId = []
      let fieldGroupsTemplate = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']
      Object.keys(fieldGroupsTemplate).forEach(fieldGroupId => {
        if (fieldGroupId === nameFieldGroup) {
          let fieldGroup = fieldGroupsTemplate[fieldGroupId]

          fieldGroup.hide = false

          let dataFieldGroupFields = {}
          Object.keys(fieldGroup.fields).forEach(field => {
            let dataField = this.$store.getters.getTemplateData(field)
            if (dataField.model !== '') tabsOrderModel.push(dataField.tabOrder)
            else tabsOrderId.push(dataField.tabOrder)

            dataFieldGroupFields[field] = dataField
          })

          let fieldGroupFields = dataFieldGroupFields

          if (tabsOrderModel.length > 0) {
            positionFieldGroup = Math.min.apply(null, tabsOrderModel)
            Object.keys(fieldGroup.fields).forEach(field => {
              let dataField = this.$store.getters.getTemplateData(field)
              if (positionFieldGroup === fieldGroup.fields[field].tabOrder) {
                pageFieldGroup = dataField.fieldPage
                groupModel = dataField.model
              }
            })
          } else {
            positionFieldGroup = Math.min.apply(null, tabsOrderId)
            Object.keys(fieldGroup.fields).forEach(field => {
              let dataField = this.$store.getters.getTemplateData(field)
              if (positionFieldGroup === fieldGroup.fields[field].tabOrder) {
                pageFieldGroup = dataField.fieldPage
                groupModel = dataField.model
              }
            })
          }

          newGroup = {
            type: 'checkbox-group',
            fieldName: fieldGroupId,
            state: 'OK',
            originalValue: '',
            newValue: '',
            itemId: 23,
            model: groupModel,
            deleted: false,
            approved: true,
            editable: true,
            values: [],
            fieldAdd: fieldGroup.fieldAdd,
            name: fieldGroup.name,
            title: fieldGroup.title,
            desc: fieldGroup.desc,
            checkboxes: fieldGroupFields,
            checked: fieldGroup.checked,
            maxChecked: this.$store.getters.fieldGroupMaxFields(fieldGroup.fieldId),
            tabOrder: positionFieldGroup,
            page: pageFieldGroup
          }
        }
      })
      let questionnaireFields = this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data']
      let tmpQuestionnaireFields = {}

      let contadorTabOrder = 0
      Object.keys(questionnaireFields).forEach((fieldId, index) => {
        if (questionnaireFields[fieldId].page === newGroup.page && contadorTabOrder === 0) {
          if (questionnaireFields[fieldId].tabOrder > newGroup.tabOrder && contadorTabOrder === 0) {
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = newGroup
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId]
            contadorTabOrder++
          } else if (contadorTabOrder === 0) {
            tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId]
          }
        } else if (questionnaireFields[fieldId].page > newGroup.page && contadorTabOrder === 0) {
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = newGroup
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId]
          contadorTabOrder++
        } else {
          tmpQuestionnaireFields[index + '-' + Math.random().toString(36).split('.')[1]] = questionnaireFields[fieldId]
        }
      })
      if (contadorTabOrder === 0) tmpQuestionnaireFields[0 + '-' + Math.random().toString(36).split('.')[1]] = newGroup
      this.$store.commit('setQuestionnaireFields', tmpQuestionnaireFields)
      this.$bus.emit('reloadQuestionnaire')
      this.$store.dispatch('saveTemplate')

      this.showModal = false
    },

    verifyFieldGroupOnQuestionnaire (nameField) {
      let response = true
      let questionnaireFields = this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data']
      Object.keys(questionnaireFields).forEach(fieldId => {
        if (questionnaireFields[fieldId].fieldName === nameField) response = false
      })
      return response
    },

    keyCheck (evt) {
      if (evt.keyCode === 27) this.closeModal()
    },

    closeModal () {
      this.showModal = false
    },

    editGroup (index) {
      this.$bus.emit('fieldGroupEditModal', index)
      this.showModal = false
    },

    deleteGroup (groupId) {
      window.swal({
        title: 'Delete Field Group?',
        text: 'You are about to delete this field group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          // Save fields on Questionnaire

          this.saveGroupFieldsOnQuestionnaire(this.groups[groupId].fields)

          this.$store.commit('removeFieldGroup', groupId)
          this.$store.dispatch('saveTemplate')
          let groupsExist = this.groups
          delete groupsExist[groupId]
          Object.assign({}, this.groups, groupsExist)
          if (Object.keys(this.groups).length === 0) this.showModal = false
          this.$bus.emit('reloadQuestionnaire')
        }
      })
    },

    saveGroupFieldsOnQuestionnaire (fields) {
      let questionnaire = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data
      let newQuestionnaireData = []

      Object.keys(questionnaire).forEach(fieldKey => {
        newQuestionnaireData.push(questionnaire[fieldKey])
      })

      Object.keys(fields).forEach(fieldKey => {
        let field = fields[fieldKey]

        let newField = {
          type: field.type,
          fieldName: field.id,
          state: 'OK',
          originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
          newValue: '',
          itemId: 23,
          model: field.model,
          prefix: field.prefix !== undefined ? field.prefix : '',
          deleted: false,
          approved: true,
          editable: true,
          values: [],
          title: field.id,
          desc: '',
          tabOrder: field.tabOrder,
          page: field.fieldPage,
          render: true,
          tags: field.tags,
          maxCharacter: Number(field.maxCharacter)
        }

        if (field.forceShow !== undefined) {
          newField.forceShow = field.forceShow
        }

        if (typeof field.translations !== 'undefined') {
          if (typeof field.translations[this.$store.state.currentLocale] !== 'undefined') {
            newField.title = field.translations[this.$store.state.currentLocale]['label']
            newField.desc = field.translations[this.$store.state.currentLocale]['text']
          }
        }

        if (newField.type === 'textarea') newField.type = 'text'
        else if (newField.type === 'radio') newField.type = 'checkbox'
        else if (newField.type === 'button') newField.type = 'checkbox'
        else if (newField.type === 'select') {
          newField.type = 'combobox'
          newField.values = field.choiceData
        }

        if (field.model === '' || field.forceShow === true) newQuestionnaireData.push(newField)
      })

      let orderQuestionnaire = this.$store.getters.orderFieldsForPage(newQuestionnaireData)

      this.$store.commit('setQuestionnaireFields', orderQuestionnaire)
    }
  }
}
</script>

<style lang="scss">
  .field-group-modal {
    position: fixed;
    top: 10%;
    left: 50%;
    margin-left: -45%;
    width: 90%;
    max-width: 1700px;
    min-height: 400px;
    max-height: 460px;
    border: 1px solid black;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background-color: #FFF;
    z-index: 100;

    .modalHeader {
      background-color: #2d5f8b;
      color: #FFF;
      font-size: 18px;
      padding: 5px 10px 5px 10px;
      height: 37px;
    }

    .btn-close {
      cursor: pointer;
      color: #FFF;
    }

    .modalBody {
      position: absolute;
      padding: 10px;
      width: 100%;
      height: calc(100% - 37px);
      overflow-y: auto;
    }
  }

  .button-box {
    float: right;
    margin-right: 30px;
    .btn {
      margin-left: 10px;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/questionnaires/FieldGroupModal.vue